/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult,
  NotFoundErrorResult,
  ResultOfListOfProductOptionViewModel,
  ValidationErrorResult,
} from '../models';
import {
    ErrorResultFromJSON,
    ErrorResultToJSON,
    NotFoundErrorResultFromJSON,
    NotFoundErrorResultToJSON,
    ResultOfListOfProductOptionViewModelFromJSON,
    ResultOfListOfProductOptionViewModelToJSON,
    ValidationErrorResultFromJSON,
    ValidationErrorResultToJSON,
} from '../models';

export interface ProductMatrixGetProductsRequest {
    proposalId: number;
}

/**
 * 
 */
export class ProductMatrixApi extends runtime.BaseAPI {

    /**
     * Get product options
     */
    async productMatrixGetProductsRaw(requestParameters: ProductMatrixGetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfListOfProductOptionViewModel>> {
        if (requestParameters.proposalId === null || requestParameters.proposalId === undefined) {
            throw new runtime.RequiredError('proposalId','Required parameter requestParameters.proposalId was null or undefined when calling productMatrixGetProducts.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v2/product-matrix/get-products/{proposalId}`.replace(`{${"proposalId"}}`, encodeURIComponent(String(requestParameters.proposalId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfListOfProductOptionViewModelFromJSON(jsonValue));
    }

    /**
     * Get product options
     */
    async productMatrixGetProducts(requestParameters: ProductMatrixGetProductsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfListOfProductOptionViewModel> {
        const response = await this.productMatrixGetProductsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
